"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenizationProviderFactory = void 0;
const tokenization_providers_constants_1 = require("../constants/tokenization-providers.constants");
const spreedly_provider_1 = require("./spreedly-provider");
const vgs_provider_1 = require("./vgs-provider");
class TokenizationProviderFactory {
    static getTokenizationProviderClient(provider, config) {
        switch (provider.toLowerCase()) {
            case tokenization_providers_constants_1.TokenizationProviders.SPREEDLY.toLowerCase():
                return new spreedly_provider_1.SpreedlyProvider(config.isProduction, config.cardNumber, config.cvv, config.firstName, config.lastName, config.expirationDate);
            case tokenization_providers_constants_1.TokenizationProviders.VGS.toLowerCase():
                return new vgs_provider_1.VGSProvider(config.isProduction, config.cardNumber, config.cvv, config.firstName, config.lastName, config.expirationDate);
            default:
                throw new Error('Provider not found');
        }
    }
}
exports.TokenizationProviderFactory = TokenizationProviderFactory;
